import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnpin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.31107 3L3 4.31107L8.63722 9.94829L7.53441 10.8592L6.16539 9.49014L4.85433 10.8012L8.37827 14.3252L3.65553 19.0461V20.3445H4.95392L9.67485 15.6217L13.1988 19.1457L14.5099 17.8346L13.2223 16.5471L14.1205 15.4316L19.6889 21L21 19.6889L15.2903 13.9793L15.2994 13.9684L10.0859 8.75674L10.0769 8.76579L4.31107 3ZM14.5099 3L13.1988 4.31107L14.231 5.34326L11.5237 7.57243L16.4692 12.5179L18.6712 9.7835L19.6889 10.8012L21 9.49014L14.5099 3Z",
		fill: "currentColor"
	})
});
export default SvgUnpin;
